export const CHARACTER_VOICE_REFERENCE_PAIR_KIND = 'characterVoice'
export const CHARACTER_VOICE_REFERENCE_EDGE_TYPE = 'reference-character-voice'

export type ReferencePairKind = typeof CHARACTER_VOICE_REFERENCE_PAIR_KIND

export function edgeTypeForReferencePairKind(kind: ReferencePairKind | undefined): string {
  return kind === CHARACTER_VOICE_REFERENCE_PAIR_KIND
    ? CHARACTER_VOICE_REFERENCE_EDGE_TYPE
    : 'default'
}

export function referencePairKindFromEdgeType(type: string): ReferencePairKind | undefined {
  return type === CHARACTER_VOICE_REFERENCE_EDGE_TYPE
    ? CHARACTER_VOICE_REFERENCE_PAIR_KIND
    : undefined
}
